module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-accounts-151a30c5df553dae654630dfb269899b.png";